import { get, post } from './common';
import { PAGE_SIZE } from 'src/constants';
// auth

export const login = (loginToken: string) => {
  return post({
    url: '/authentication/mbapp/login',
    params: { token: loginToken },
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
  });
};

export const getUserInfo = () => {
  return get({ url: '/authentication/mbapp/userinfo' });
};

export const refreshToken = (refreshToken?: string) => {
  return post({
    url: '/authentication/refresh-token',
    params: { refreshToken },
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
  });
};

// home

export const getHomeBanner = () => {
  return get({ url: '/api/web-booking/get-banner-on-home' });
};

export const getHomeProduct = () => {
  return get({
    url: '/api/web-booking/get-products-on-home',
  });
};

export const getAllProduct = (productType: string) => {
  return get({
    url: '/api/web-booking/get-all-products',
    params: productType ? { productType } : null,
  });
};

export const getHomeEvent = () => {
  return get({ url: '/api/web-booking/get-event-new-promotion-on-home' });
};

export const getAllNews = (pageNumber = 1, pageSize = PAGE_SIZE) => {
  return post({
    url: '/api/web-booking/get-all-event-new',
    params: { pageNumber, pageSize },
  });
};

export const getAllPromotion = () => {
  return get({ url: '/api/web-booking/get-all-promotion' });
};

export const getHomeOnlineProduct = () => {
  return get({ url: '/api/web-booking/get-product-onlines-on-home' });
};

export const getAllOnlineProduct = () => {
  return get({ url: '/api/web-booking/get-all-product-onlines' });
};

// cancer
export const getCategory = (productCode: string) => {
  return get({ url: '/api/web-booking/all-category', params: { productCode } });
};

export const checkValidUserInfo = (
  dob: string,
  gender: string,
  nationality: string
) => {
  return post({
    url: '/api/web-booking/check-valid-user-info',
    params: { dob, gender, nationality },
  });
};

export const getInsurancePackage = (
  dob: string,
  gender: string,
  nationality: string
) => {
  return post({
    url: '/api/web-booking/cancer/check-valid-get-insurance-packages',
    params: { dob, gender, nationality },
  });
};

export const checkBpTsaCancer = (
  sumAssured: number,
  idCardNo: string,
  fullname: string,
  dob: string,
  gender: string
) => {
  return post({
    url: '/api/web-booking/cancer/check-bp-tsa',
    params: { sumAssured, idCardNo, fullname, dob, gender },
  });
};

// Cancer Voucher
export const getVouchers = () => {
  return get({ url: '/api/web-booking/cancer/get-vouchers' });
};

export const applyVoucher = (
  saCode: string,
  premiumBeforeDiscount: number,
  voucherCode: string
) => {
  return post({
    url: '/api/web-booking/cancer/apply-voucher',
    params: { saCode, premiumBeforeDiscount, voucherCode },
  });
};

export const checkDiscount = (params: any) => {
  return post({ url: '/api/web-booking/check-discount', params });
};

export const createOrder = (params: any) => {
  return post({
    url: '/api/web-booking/cancer/create-order',
    params,
  });
};

// fee
export const getInquiryHsycbh = (applNo: string) => {
  return post({
    url: '/api/inquiry/search',
    params: { applNo },
  });
};

export const createInquiryHsycbh = (requestId: string) => {
  return post({
    url: '/api/inquiry/create-order',
    params: { requestId },
  });
};

// my policy

export const getListAllPolicy = (identificationType, inquiryInformation, dob) => {
  return get({ url: '/api/policy/inquiry', params: { identificationType, inquiryInformation, dob } });
};

export const getPeriodicPolicyByPolicyNum = (policyNum) => {
  return get({ url: '/api/periodic/search/policy', params: { policyNum } });
};

export const getPeriodicPolicyByPolicyNumNew = (policyNum, birthDate) => {
  return get({ url: '/api/periodic/search/policy-new', params: { policyNum, birthDate } });
};

export const getTopUpPolicyByPolicyNum = (policyNum) => {
  return get({ url: '/api/top-up/search', params: { policyNum } });
};

export const getTopUpPolicyByPolicyNumNew = (policyNum, birthDate) => {
  return get({ url: '/api/top-up/search-new', params: { policyNum, birthDate } });
};

export const createOrderPeriodic = (params) => {
  return post({ url: '/api/periodic/create-order', params: params });
};

export const createOrderTopUp = (params) => {
  return post({ url: '/api/top-up/create-order', params: params });
};

export const getListPeriodicPolicyByIdCard = (idType, idNumber, birthDate) => {
  return get({ url: '/api/periodic/search/id-number', params: { idType, idNumber, birthDate } });
};

export const getListPeriodicPolicyByPolicyNumber = (policyNum) => {
  return get({ url: '/api/periodic/search/policy', params: { policyNum } });
};

export const getPolicyToCancel = (params) => {
  return get({ url: '/api/terminate', params: params });
};

export const cancelPolicy = (params) => {
  return post({ url: '/api/terminate', params: params });
};

export const gaTrackEvent = (pub: string, eventName: string, clientId: string) => {
  return post({
    url: '/api/tracking',
    params: { pub, eventName, clientId },
  });
};

export const submitSpecialOffers = (rmCode: string, rmName: string) => {
  return post({
    url: '/api/special-offers',
    params: { rmCode, rmName },
  });
};

export const submitSpecialOffersLocalAccountCampaign = (rmCode: string) => {
  return post({
    url: '/api/special-offers/local-account',
    params: { rmCode },
  });
};

export const createOtp = (
  idCardNo: string,
  phone: string,
  type: string,
  policyNumber: string,
) => {
  return post({
    url: "/api/frontend/verification-request",
    params: {
      idCardNo,
      phone,
      type,
      policyNumber
    },
  });
};

export const wakandaLogActionApi = ({
  actionType,
  eventDirectory,
  logId,
  logName,
  deviceOs,
  idCardNo,
  cif,
}: {
  actionType: string,
  eventDirectory: string,
  logId: string,
  logName: string,
  deviceOs: string,
  idCardNo: string,
  cif: string,
}) => {
  return post({
    url: '/api/wakanda-action-log',
    params: {
      actionType,
      eventDirectory,
      logId,
      logName,
      deviceOs,
      idCardNo,
      cif
    },
  });
};

export const getEmployeeInfo = (rmCode: string) => {
  return post({
    url: '/api/special-offers/employee-set',
    params: { rmCode }
  });
}


//  ========= AUTO PAYMENT ============

export const getAutoDebitsAPI = () => {
  return get(
    {
      url: `/api/auto-debit/get-list-auto-debit`,
    },
  );
};

export const registerAutoDebitAPI = (
  body: {
    policyNumber: number | string,
    phName: string
  },
) => {
  return post(
    {
      url: '/api/auto-debit/register',
      params: body,
    },
  );
};

export const cancelRegisterAutoDebitAPI = (
  body: {
    policyNumber: number | string,
    phName: string,
    recordId: string | null,
    autoDebitId: string | null
  }
) => {
  return post({
    url: '/api/auto-debit/cancel',
    params: body
  })
}
